import { Column } from '@components/ListV2/components/table/VirtualizedTable.types';
import { ReactNode } from 'react';
import { OrderListTabName } from '../../../list/orderListTabs';
import { OrderListWithBaseItem } from '../../../order.types';
import {
  UseOrderFilterV2Result,
  useOrderFilterV2,
} from '../../../orderFilter/hooks/useOrderFilterV2';

interface OrderListFiltersConfig {
  columns: Column<OrderListWithBaseItem>[];
  selectedTab: OrderListTabName;
  selectedIds: string[];
}

interface OrderListPageFiltersProps {
  filtersConfig: OrderListFiltersConfig;
  children: (filters: UseOrderFilterV2Result) => ReactNode;
}

const OrderListPageFilters = ({ filtersConfig, children }: OrderListPageFiltersProps) => {
  const filters = useOrderFilterV2({
    ...filtersConfig,
    includeDateFilter: false,
  });

  return children(filters);
};

export default OrderListPageFilters;
